import { InventoryType, StatusLevel } from '@scaleaq/sitecontrol-lib';

import { DeviceConfigSearch } from './deviceConfigPage.types.ts';

const INVENTORY_TYPE_SET = new Set<string>(Object.values(InventoryType));
const STATUS_LEVEL_SET = new Set<string>(Object.values(StatusLevel));

/**
 * TanStack Router `validateSearch` for `/utils/deviceConfig`.
 * `q` is trimmed on read so it matches what `useDeviceConfigSearch` writes to the URL.
 */
export const parseDeviceConfigSearch = (search: Record<string, unknown>): DeviceConfigSearch => {
  const trimmedQ = typeof search.q === 'string' ? search.q.trim() : '';
  const q = trimmedQ.length > 0 ? trimmedQ : undefined;

  const typesList = uniqueStrings(splitSearchList(search.types).filter(isInventoryType));
  const types = typesList.length > 0 ? typesList : undefined;

  const statusList = uniqueStrings(splitSearchList(search.status).filter(isStatusLevel));
  const status = statusList.length > 0 ? statusList : undefined;

  return { q, types, status };
};

//************************
// Help Functions
//************************

const splitSearchList = (raw: unknown): string[] => {
  if (raw === undefined || raw === null || raw === '') {
    return [];
  }
  if (Array.isArray(raw)) {
    return raw.flatMap(entry =>
      String(entry)
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
    );
  }
  if (typeof raw === 'string') {
    return raw
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }
  return [];
};

const isInventoryType = (value: string): value is InventoryType => INVENTORY_TYPE_SET.has(value);

const isStatusLevel = (value: string): value is StatusLevel => STATUS_LEVEL_SET.has(value);

const uniqueStrings = <T extends string>(values: T[]): T[] => [...new Set(values)];
